import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.972 12.833C25.826 7.43 21.464 3.04 16.076 3a9.9 9.9 0 0 0-5.008 1.306 1 1 0 0 0 .992 1.737 7.9 7.9 0 0 1 4-1.043c4.374.033 7.916 3.673 7.916 8.113V14l.004.512c.045 2.87.47 5.19 1.19 7.019a1 1 0 0 0 1.861-.732c-.666-1.693-1.055-3.933-1.055-6.799v-.887zM6.74 4.327l-.09-.087a1 1 0 0 0-1.39 1.433L7.366 7.99a10 10 0 0 0-1.34 5.012V14l-.004.437c-.048 3.451-.67 5.913-1.624 7.555A1.998 1.998 0 0 0 6.12 25H11l.005.217A5 5 0 0 0 21 25h1.83l2.43 2.673.09.087a1 1 0 0 0 1.39-1.433zM16 28a3 3 0 0 1-3-3h6l-.005.176A3 3 0 0 1 16 28M8.03 12.675 8.025 13v1c0 3.859-.66 6.728-1.76 8.752l-.14.248h14.887L8.797 9.563a8 8 0 0 0-.766 3.112"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconBellSlash = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconBellSlash);
export default Memo;
